import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Trash2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const LogoUploader = ({ logoPath, onChange, kind = "logo", label = "Logo", hint = "Tampil di kop PDF penawaran & laporan." }) => {
  const [src, setSrc] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let url = "";
    if (!logoPath) return setSrc("");
    api.get(`/settings/asset/${kind}`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => setSrc(""));
    return () => url && URL.revokeObjectURL(url);
  }, [logoPath, kind]);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/settings/asset/${kind}`, fd);
      onChange(data);
      toast.success(`${label} berhasil diupload`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    const { data } = await api.delete(`/settings/asset/${kind}`);
    onChange(data);
    toast.success(`${label} dihapus`);
  };

  return (
    <div className="flex flex-wrap items-center gap-5">
      <div className="grid h-24 w-48 place-items-center overflow-hidden rounded-xl border-2 border-dashed border-slate-300 bg-white" data-testid={`${kind}-preview`}>
        {src ? <img src={src} alt={label} className="max-h-20 max-w-[180px] object-contain" /> : <span className="text-xs text-slate-400">Belum ada {label.toLowerCase()}</span>}
      </div>
      <div className="flex flex-col gap-2">
        <label className="inline-flex cursor-pointer items-center rounded-md bg-[#1E3A8A] px-4 py-2 text-sm font-medium text-white hover:bg-[#1E293B] transition-colors">
          <ImagePlus className="h-4 w-4 mr-2" />{busy ? "Mengupload..." : `Upload ${label}`}
          <input type="file" accept="image/png,image/jpeg" className="hidden" disabled={busy} onChange={(e) => upload(e.target.files[0])} data-testid={`${kind}-file-input`} />
        </label>
        {logoPath && <Button variant="ghost" size="sm" onClick={remove} data-testid={`${kind}-remove-btn`}><Trash2 className="h-4 w-4 mr-1 text-rose-500" />Hapus {label}</Button>}
        <p className="text-xs text-slate-500">PNG/JPG, maks 2 MB. {hint}</p>
      </div>
    </div>
  );
};
